<app-group-header [Heading]="'Positionierung'"
				  [chart]="chart"
				  [info]="info"
				  (chartEvent)="getChartEvent($event)"
				  (infoEvent)="getInfoEvent($event)">
</app-group-header>

<div class="card-group">

	<app-default-card class="card" style="border: none; border-radius: unset;"
					  [Heading]="'X-Position'"
					  [Error]="xPosition?.isError"
					  [ErrorLevel]="xPosition?.status"
					  [showChart]="chart"
					  [showInfo]="info"
					  [Values]="[xPosition?.TimeseriesData]"
					  [Legend]="['X-Position']"
					  [resizeEvent]="childResizeEvent">
	</app-default-card>

	<app-default-card class="card" style="border: none; border-radius: unset;"
					  [Heading]="'Z-Position'"
					  [Error]="zPosition?.isError"
					  [ErrorLevel]="zPosition?.status"
					  [showChart]="chart"
					  [showInfo]="info"
					  [Values]="[zPosition?.TimeseriesData]"
					  [Legend]="['Z-Position']"
					  [resizeEvent]="childResizeEvent">
	</app-default-card>

	<app-default-card class="card" style="border: none; border-radius: unset;"
					  [Heading]="'Ebene'"
					  [Error]="level?.isError"
					  [ErrorLevel]="level?.status"
					  [showChart]="chart"
					  [showInfo]="info"
					  [Values]="[level?.TimeseriesData]"
					  [Legend]="['Ebene']"
					  [resizeEvent]="childResizeEvent">
	</app-default-card>

	<app-default-card class="card" style="border: none; border-radius: unset;"
					  [Heading]="'Hub oben'"
					  [Error]="liftTop?.isError"
					  [ErrorLevel]="liftTop?.status"
					  [showChart]="chart"
					  [showInfo]="info"
                      [customTemplate]="custom"
                      [customNoData]="liftTop == null"
					  [Legend]="['Hub oben']"
					  [resizeEvent]="childResizeEvent">
	</app-default-card>

    <ng-template #custom>
        <div *ngIf="liftTop?.TimeseriesData?.currentDatapoint.value === 0">
            {{'Nein' | translate}}
        </div>
        <div *ngIf="liftTop?.TimeseriesData?.currentDatapoint.value === 1">
            {{'Ja' | translate}}
        </div>
    </ng-template>

</div>
